import { useContext, useState, useEffect } from "react";
import inputStyle from "../../styles/input.module.scss";
import { MaterialContext } from "../../context/MaterialContext";
import axios from "axios";
import DragDrop from "./DragDrop";
import Dropzone from "./Dropzone";
import { closeIcon } from "../../components/Icons";
import PreviewSwatch from "./PreviewSwatch";
import ImagePreviewFrame from "./ImagePreviewFrame";

function ImageAdd({
  vendor,
  slug,
  data,
  setMaterialArray,
  materialDescription,
}) {
  const { ROOT_SERVER } = useContext(MaterialContext);
  const [images, setImages] = useState([]);
  const [folder, setFolder] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [uploadedImages, setUploadedImages] = useState(false);

  useEffect(() => {
    setMaterialArray(images);
  }, [images, setMaterialArray]);

  function getData({ refreshFolderOnly = false } = {}) {
    const materialGet = `${ROOT_SERVER}material/${vendor}/${slug}`;
    const folderGet = `${ROOT_SERVER}material/folder/${vendor}/${slug}`;

    if (refreshFolderOnly) {
      axios
        .get(folderGet)
        .then((response) => {
          if (Array.isArray(response.data) && response.data.length) {
            setFolder(response.data);
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
      return;
    }

    axios
      .all([axios.get(materialGet), axios.get(folderGet)])
      .then(
        axios.spread((responseMaterials, responseFolder) => {
          const material = responseMaterials.data?.[0];
          if (material?.images) {
            setImages(material.images);
            setPreviewImage(material.images[0] || "");
          }
          if (Array.isArray(responseFolder.data) && responseFolder.data.length) {
            setFolder(responseFolder.data);
          }
        }),
      )
      .catch((errors) => {
        console.log(errors);
      });
  }
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [data, vendor, slug]);

  useEffect(() => {
    if (uploadedImages) {
      getData({ refreshFolderOnly: true });
      setUploadedImages(false);
    }
    // eslint-disable-next-line
  }, [uploadedImages]);

  const handleAddImageFromFolder = (image) => {
    const newValue = [...images, image];
    setImages(newValue);
  };

  const handleUploadSuccess = (uploadedNames) => {
    const nextNames = Array.isArray(uploadedNames) ? uploadedNames : [];
    setImages((currentImages) => {
      const nextImages = [...currentImages];
      nextNames.forEach((name) => {
        if (!nextImages.includes(name)) {
          nextImages.push(name);
        }
      });
      return nextImages;
    });
    if (nextNames[0]) {
      setPreviewImage(nextNames[0]);
    }
  };
  const handleAlreadyInculded = () => {
    alert("its already included");
  };

  const handleDeleteFromFolder = (item) => {
    alert(`ARE YOU SURE YOU WANT TO DELETE ${item}`);
    axios
      .delete(
        `${ROOT_SERVER}upload/delete/${item}`,

        {
          headers: {
            "Content-Type": "application/json",
          },
          data: { vendor: vendor, slug: slug },
        },
      )
      .then(() => {
        getData();
      });
  };

  return (
    <div className={inputStyle.imageWorkspace}>
      <div className={inputStyle.imageColumns}>
        <section className={inputStyle.imageColumn}>
          <div className={inputStyle.previewHeader}>
            <div className={inputStyle.previewSlot}>
              <p className={inputStyle.imagePreviewLabel}>Swatch preview</p>
              <div className={inputStyle.swatchView}>
                <PreviewSwatch
                  images={images}
                  vendor={vendor}
                  slug={slug}
                  materialDescription={materialDescription}
                />
              </div>
            </div>
            <div className={inputStyle.previewSlot}>
              <p className={inputStyle.imagePreviewLabel}>Image preview</p>
              <ImagePreviewFrame
                src={
                  previewImage
                    ? `${ROOT_SERVER}${vendor}/${slug}/swatch/${previewImage}`
                    : ""
                }
                alt={previewImage || "swatch preview"}
                emptyLabel="Click an image on the right to preview"
              />
            </div>
          </div>
        </section>

        <section className={inputStyle.imageColumn}>
          <h4 className={inputStyle.imageSectionHeading}>Swatch Order</h4>
          <DragDrop
            images={images}
            vendor={vendor}
            slug={slug}
            setImages={setImages}
            setPreviewImage={setPreviewImage}
          />

          <h4 className={inputStyle.imageSectionHeading}>Available Images</h4>
          <div
            className={`${inputStyle.inputSwatchContainer} ${inputStyle.imagePanel}`}
          >
            <div className={inputStyle.inputSwatchHeader}>
              <div className={inputStyle.inputSwatchHeaderTitle}>FILES</div>
            </div>
            {folder.length === 0 ? (
              <div className={inputStyle.dragDropEmpty}>No files found</div>
            ) : null}
            {folder?.map((item, i) => (
              <div key={item} className={inputStyle.dragDropItem}>
                {images.includes(item) ? null : (
                  <div
                    className={inputStyle.deleteDragDropItem}
                    onClick={() => handleDeleteFromFolder(item)}
                  >
                    <div className={inputStyle.deleteIcon}>{closeIcon}</div>
                  </div>
                )}
                <img
                  src={`${ROOT_SERVER}${vendor}/${slug}/thumbnail/${item}`}
                  alt={item + "folder" + i}
                  onClick={() => setPreviewImage(item)}
                />
                <div
                  className={inputStyle.folderItemAdd}
                  onClick={
                    !images.includes(item)
                      ? () => handleAddImageFromFolder(item)
                      : handleAlreadyInculded
                  }
                >
                  {images.includes(item) ? "In View" : "add"}
                </div>
              </div>
            ))}
          </div>

          <h4 className={inputStyle.imageSectionHeading}>Upload</h4>
          <div
            className={`${inputStyle.inputSwatchContainer} ${inputStyle.imagePanel}`}
          >
            <div className={inputStyle.inputSwatchHeader}>
              <div className={inputStyle.inputSwatchHeaderTitle}>UPLOAD</div>
            </div>
            <Dropzone
              vendor={vendor}
              slug={slug}
              setUploadedImages={setUploadedImages}
              onUploadSuccess={handleUploadSuccess}
            />
          </div>
        </section>
      </div>
    </div>
  );
}

export default ImageAdd;
